import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';
import LoadingScreen from '@/components/common/LoadingScreen';

export default function GuestGuard() {
  const { accessToken, userInfo, _hasHydrated } = useAuthStore();

  // Wait for Zustand to rehydrate from localStorage
  if (!_hasHydrated) {
    return <LoadingScreen />;
  }

  if (accessToken) {
    // Wait for userInfo to be loaded before redirecting
    if (!userInfo) {
      console.log('⏳ [GuestGuard] Token exists but userInfo not loaded yet, waiting...');
      return <LoadingScreen />;
    }

    // Redirect based on user type
    const userType = userInfo.user_type;
    console.log('🚪 [GuestGuard] User authenticated, redirecting based on type:', userType);

    let redirectPath = '/dashboard';
    if (userType === 'supplier') {
      redirectPath = '/dashboard/supplier';
    } else if (userType === 'customer') {
      redirectPath = '/dashboard/customer';
    } else if (userType === 'admin') {
      redirectPath = '/dashboard';
    } else {
      console.warn('⚠️ [GuestGuard] Unknown user type:', userType, '- redirecting to /dashboard');
    }

    console.log('🚪 [GuestGuard] Redirecting to:', redirectPath);
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
}
